/* unplugin-vue-components disabled */import script from "./slideHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./slideHeader.vue?vue&type=script&lang=ts&setup=true"

import "./slideHeader.vue?vue&type=style&index=0&id=cad1f79c&lang=scss&scoped=true"

import exportComponent from "/nerv.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cad1f79c"]])

export default __exports__